//@flow
import React from 'react';
import {
  FontAwesomeIcon as FontAwesome
} from '@fortawesome/react-fontawesome';
import {
  faCopy,
  faCheck
} from '@fortawesome/free-solid-svg-icons'
import {
  copyToClipboard
} from 'lib/Helpers';

type Props = {
  copyData: string
}
type State = {
  copyIcon: Object
}
class CopyButton extends React.Component < Props, State > {
  state = {
    copyIcon: faCopy
  }

  handleCopyToClipboard() {

    copyToClipboard(this.props.copyData);

    this.setState({
      copyIcon: faCheck
    });
    setTimeout(() => this.setState({
      copyIcon: faCopy
    }), 5000)
  }


  render() {

    return <FontAwesome icon={this.state.copyIcon} onClick={()=>this.handleCopyToClipboard()}/>
  }
}
export default CopyButton;